const FacebookPost = () => import('./FacebookPost')
const SqwizArticle = () => import('./SqwizArticle')
const TwitterTweet = () => import('./TwitterTweet')
const InformacijaPost = () => import('./InformacijaPost')
const WordpressPost = () => import('./WordpressPost')
const SqwizProduct = () => import('./SqwizProduct')
const InformacijaProduct = () => import('./InformacijaProduct')
const WoocommerceProduct = () => import('./WoocommerceProduct')

export { FacebookPost, SqwizArticle, TwitterTweet, InformacijaPost, WordpressPost, SqwizProduct, InformacijaProduct, WoocommerceProduct }



// WEBPACK FOOTER //
// ./src/components/standard/formatter/type/index.js